module.exports = __webpack_public_path__ + "static/img/DSC_0067.e9d0246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0067.jpg
// module id = QCpq
// module chunks = 0